<template>
  <div class="ChevronSectionComponent">
    <div class="content" :class="[color,textColor,chevronClass]"
         :style="[cssStyle,colorStyle]">
      <div class="bounding-box" :style="boundingBoxStyle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ChevronSection',
    components: {},
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
      color: {
        type: String,
        default: ''
      },
      textColor: {
        type: String,
        default: ''
      },
      top: {
        type: Boolean,
        default: false
      },
      bottom: {
        type: Boolean,
        default: false
      },
      background: {
        type: String,
        default: ''
      },
      backgroundPosition: {
        type: String,
        default: 'center'
      },
      height: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: ''
      },
      colorHex: {
        type: String,
        default: ''
      }
    },
    computed: {
      chevronClass () {
        if (this.top) {
          return 'chevron-top'
        } else if (this.bottom) {
          return 'chevron-bottom'
        } else {
          return 'chevron'
        }
      },
      colorStyle () {
        if (this.colorHex !== '') {
          return {
            backgroundColor: this.colorHex
          }
        }
        return {}
      },
      boundingBoxStyle () {
        let theStyle = {}
        if (this.height !== '') {
          theStyle['min-height'] = this.height
        }
        if (this.width !== '') {
          theStyle['min-width'] = this.width
        }
        return theStyle
      },
      cssStyle () {
        let theStyle = {
          backgroundImage: `url('${this.background}')`,
          backgroundPosition: this.backgroundPosition
        }

        return theStyle
      }
    },
    watch: {},
    data: function () {
      return {}
    },
    methods: {},
    created () {
    },
    mounted () {
    }
  }
</script>

<style scoped>

  .ChevronSectionComponent {
    --chevron-offset: 30px;
    filter: drop-shadow(0 0px 3px rgba(0, 0, 0, 0.7));

    .content {
      background-size: cover;
      background-position: center;

      .bounding-box {
        padding: calc(var(--chevron-offset) * 2) 0 calc(var(--chevron-offset) * 2) 0;
      }
    }

    .chevron {
      clip-path: polygon(0% 0%, 50% var(--chevron-offset), 100% 0%, 100% calc(100% - var(--chevron-offset)), 50% 100%, 0% calc(100% - var(--chevron-offset)));
    }

    .chevron-top {
      clip-path: polygon(0% 0%, 50% var(--chevron-offset), 100% 0%, 100% 100%, 0% 100%);
    }

    .chevron-bottom {
      clip-path: polygon(0% 0%, 100% 0%, 100% calc(100% - var(--chevron-offset)), 50% 100%, 0% calc(100% - var(--chevron-offset)));
    }

    /*.content-box {*/
    /*clip-path: polygon(0% 00.04%, 2% 00.44%, 4% 00.35%, 6% 00.78%, 8% 00.69%, 10% 00.06%, 12% 00.50%, 14% 00.55%, 16% 00.72%, 18% 00.77%, 20% 00.76%, 22% 00.10%, 24% 00.06%, 26% 00.08%, 28% 00.56%, 30% 00.42%, 32% 00.87%, 34% 00.67%, 36% 00.91%, 38% 00.68%, 40% 00.49%, 42% 00.61%, 44% 00.82%, 46% 00.66%, 48% 00.59%, 50% 00.40%, 52% 00.93%, 54% 00.57%, 56% 00.43%, 58% 00.80%, 60% 00.44%, 62% 00.48%, 64% 00.82%, 66% 00.34%, 68% 00.08%, 70% 00.65%, 72% 00.62%, 74% 00.64%, 76% 00.51%, 78% 00.55%, 80% 00.43%, 82% 01.00%, 84% 00.71%, 86% 00.43%, 88% 00.63%, 90% 00.98%, 92% 00.88%, 94% 00.56%, 96% 00.02%, 98% 00.39%, 100% 00.77%, 100% 99.63%, 98% 99.04%, 96% 99.73%, 94% 99.67%, 92% 99.89%, 90% 99.11%, 88% 99.66%, 86% 99.77%, 84% 99.62%, 82% 99.85%, 80% 99.81%, 78% 99.05%, 76% 99.07%, 74% 99.25%, 72% 99.15%, 70% 99.19%, 68% 99.74%, 66% 99.23%, 64% 99.45%, 62% 99.41%, 60% 99.91%, 58% 99.25%, 56% 99.52%, 54% 99.73%, 52% 99.13%, 50% 99.84%, 48% 99.27%, 46% 99.43%, 44% 99.35%, 42% 99.66%, 40% 99.8%, 38% 99.44%, 36% 99.92%, 34% 99.41%, 32% 99.42%, 30% 99.99%, 28% 99.14%, 26% 99.11%, 24% 99.45%, 22% 99.17%, 20% 99.82%, 18% 99.88%, 16% 99.87%, 14% 99.67%, 12% 99.12%, 10% 99.23%, 8% 99.95%, 6% 99.91%, 4% 99.86%, 2% 99.13%, 0% 99.45%);*/
    /*}*/
  }
</style>
